import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
}));

const Form = ({ addTodo }) => {
    // const classes = useStyles();
    const [value, setValue] = useState('')

    const handleSubmit = e => {
        e.preventDefault()
        if (value === "") {
            alert("フォームが空白です")
        } else {
            addTodo(value)
            setValue('')
        }
    }


    return (
        <form className="todoText" onSubmit={handleSubmit}>
            <TextField type='text' style={{ width: "100%", marginTop: "20px" }} id="outlined-basic" label="" variant="outlined"
                value={value}
                onChange={e => {
                    setValue(e.target.value)
                }
                }
            />
        </form>
    )
}


export default Form
